import { render, staticRenderFns } from "./memberinfo-practioner.vue?vue&type=template&id=84ecb66e"
import script from "./memberinfo-practioner.vue?vue&type=script&lang=js"
export * from "./memberinfo-practioner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports